module.exports = __webpack_public_path__ + "static/media/YF92_1.60db2a18.jpg";